import React from 'react';
import * as _ from 'lodash';

import Helmet from 'react-helmet';
import Tippy from '../components/ReactTippy';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import masterSlideLoader from '../utilities/masterSlideLoader';
import UserApi from '../services/user/UserApi';

import dialogLoader from '../utilities/dialogLoader';
import { isLoginUserPartner } from '../utilities/roleUtility';
import { messageUtility } from '../utilities/messageUtility';
import { fileSizeCheck, fileTypeCheck } from '../utilities/fileType';
import {
  CORPORATE_ADMINISTRATOR_MANUAL,
  HEADER_CONSTANTS,
  MANAGER_REQUEST_FILE_MAX_SIZE,
  USER_ROLES,
} from '../utilities/constants';
import PrintUtility from '../utilities/printUtility';
import { isTargetRoleId } from '../utilities/roleUtility';
import { MasterPageHeader } from '../components/PageHeader';
import Styles from '../styles/componentStyle/buildeeManagerRequest/buildeeManagerRequest.scss';
import { BuildeeManagerRequestScheme } from '../utilities/JoiSchemes';
import {
  FormList,
  FormListItem,
  FormElement,
} from '../components/CommonFormComponents';
import { validationByJoi } from '../utilities/commonValidation';
import BuildeeManagerRequestApi from '../services/buildeeManagerRequest/BuildeeManagerRequestApi';
import ImageUtility from '../utilities/imageUtility';
import {
  isNullOrEmpty,
  isNullOrUndefined,
  safariOnIosCheck,
} from '../utilities/stringUtil';
import { Confirmation, Information } from '../components/modals/common';
import { BuildeeManagerApplyingModal } from '../components/modals/BuildeeManagerApplyingModal';
import { TrashIcon } from '../components/icons/TrashIcon';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { Description } from '../components/Description';
import ImageGuideManagerRequest from './../images/buildee_manager_request_guide_1.svg';

/**
 * 企業管理者の申請画面
 */
export class BuildeeManagerRequest extends React.Component {
  constructor(props) {
    super(props);

    const roleId = LocalStorageService.getRoleId();

    this.state = {
      params: {
        company_id: '',
        company_name: '',
        company_branch_id: '',
        company_branch_name: '',
        user_id: '',
        user_name: '',
        user_role_code: null,
        request_message: '',
        file: null,
        file_name: '',
        image_url: '',
      }, // フォームの値を保持
      confirmDialogFlg: false, //送信確認ダイアログ
      validationMessage: {}, //バリデーションメッセージ
      searchUser: {
        company_id: SessionStorageService.getCompanyId(),
        block_flag: 0,
        user_role_code: isLoginUserPartner()
          ? USER_ROLES.partner.id
          : USER_ROLES.prime.id,
      },
      agreed: false,
      confirmed: false,
      visibleDownloadErrorDialog: false,
    };

    this.isRequesting = false; // 「内容を確認して申請する」ボタンの連打防止対応

    this.companyId = SessionStorageService.getCompanyId();
    this.userId = LocalStorageService.getUserId();
  }

  setVisibleDownloadErrorDialog = bool => {
    this.setState({
      visibleDownloadErrorDialog: bool,
    });
  };

  componentDidMount() {
    const state = _.cloneDeep(this.state);
    const sessionPrimeCompanyId = SessionStorageService.getItem(
      'sessionPrimeCompanyId'
    );
    if (isLoginUserPartner() && sessionPrimeCompanyId) {
      state.searchUser.prime_company_id = sessionPrimeCompanyId;
    }
    this.setState(state, () => {
      this.changeUser(this.userId);
    });
  }

  getSelectedCompanyInfo = companies => {
    let selectedCompanyInfo = null;
    const sessionPartnerCompanyIdOfPrimeCompany = SessionStorageService.getItem(
      'sessionPartnerCompanyIdOfPrimeCompany'
    );
    if (sessionPartnerCompanyIdOfPrimeCompany) {
      selectedCompanyInfo = _.find(companies, company => {
        return String(company.id) === sessionPartnerCompanyIdOfPrimeCompany;
      });
    }
    return selectedCompanyInfo;
  };

  /**
   * ユーザーを選択する
   * @param {string} value: 選択したユーザーのID
   */
  changeUser = async value => {
    const state = _.cloneDeep(this.state);

    if (state.params.user_id === Number(value)) {
      return;
    }

    UserApi.fetch(value)
      .then(res => {
        if (res.result) {
          const user = res.data.entities.user;
          state.params.user_id = user.id;
          state.params.user_name = user.fullname;

          let company = user.company[0];
          if (isLoginUserPartner()) {
            company = this.getSelectedCompanyInfo(user.company);
            if (!company) {
              throw new Error('会社名の取得に失敗しました');
            }
          }
          state.params.company_id = company.id;
          state.params.company_name = company.name;
          state.params.user_role_code = user.user_role.code;
          if (!_.isEmpty(user.company_branch)) {
            const selectedCompanyBranchInfo = _.find(
              user.company_branch,
              company_branch => {
                return company_branch.company_id === company.id;
              }
            );
            state.params.company_branch_id = selectedCompanyBranchInfo.id;
            state.params.company_branch_name = selectedCompanyBranchInfo.name;
          }
          this.setState(state);
        } else {
          let errorMessage = '';
          if (res.message) {
            errorMessage = messageUtility.getMessage('E-000-007', res.message);
          } else if (res.data.message) {
            errorMessage = messageUtility.getMessage(
              'E-000-007',
              res.data.message
            );
          }
          this.showDialog(errorMessage);
        }
      })
      .catch(error => {
        let errorMessage = '';
        if (error.message) {
          errorMessage = messageUtility.getMessage('E-000-007', error.message);
        } else if (error.data.message) {
          errorMessage = messageUtility.getMessage(
            'E-000-007',
            error.data.message
          );
        }
        this.showDialog(errorMessage);
      });
  };

  uploadFile = async target => {
    if (!target.files[0]) {
      return;
    }

    const file = target.files[0]; //ファイルを取得
    const size = await fileSizeCheck(file, MANAGER_REQUEST_FILE_MAX_SIZE);
    const type = await fileTypeCheck(file, ['jpeg', 'jpg', 'png', 'pdf']);
    const hasError = !size || !type;
    const state = _.cloneDeep(this.state);
    if (hasError) {
      // 既存のファイル情報はクリア
      state.params.file_name = '';
      state.params.file = null;
      state.params.image_url = '';

      const messages = {};
      if (!type) {
        messages.file_name = messageUtility.getMessage(
          'E-000-038',
          'JPEG、PNG、PDF'
        );
      }
      if (!size) {
        messages.file_name = messageUtility.getMessage('E-000-046', '10');
      }
      state.validationMessage = messages;
      this.setState(state);
    } else {
      const reader = new FileReader();
      reader.onload = async () => {
        // ファイル読み込み成功時
        const state = _.cloneDeep(this.state);
        state.params.file_name = target.files[0].name;
        state.params.file = file;
        const isImageType = await ImageUtility.approvalFileType(file, [
          'jpg',
          'jpeg',
          'png',
        ]);
        if (isImageType === true) {
          state.params.image_url = URL.createObjectURL(file);
        } else {
          state.params.image_url = '';
        }
        let result = this.getValidateResult(state.params);
        state.validationMessage = result.messages;
        this.setState(state);
      };
      reader.readAsDataURL(file);
    }
  };

  /**
   * ファイル情報をクリアする
   */
  clearFile = () => {
    const state = _.cloneDeep(this.state);
    state.params.file = null;
    state.params.file_name = '';
    state.params.image_url = '';
    this.setState(state);
  };

  fileInputForm = () => {
    const renderInfoBlock = () => {
      return (
        <React.Fragment>
          <p>(JPEG、PNG、PDFのみ。10MBまで)</p>
          <div className='manager-request__attention'>
            {messageUtility.getMessage('W-000-026')}
          </div>
          <Description type='primary'>
            <div className='manager-request__description--header'>
              {messageUtility.getMessage('W-000-027')}
            </div>
            <ul className='manager-request__description--list'>
              <li>
                名刺をスマホのカメラで撮影して、名刺の周りに余白が残っていること。
              </li>
              <li>
                必要事項が名刺の裏表に記載されている場合は名刺を2枚用意していただき表・裏が見える状態で撮影し、一つの画像内に収めてください。（
                <span className='bold'>撮影例</span> 2をご参照ください）
              </li>
              <li>
                スキャンする場合は、拡張子をJPEGにしてから添付してください。
              </li>
              <li>
                申請者本人が会社に所属していることが確認できる名刺を添付してください。
              </li>
            </ul>
          </Description>
        </React.Fragment>
      );
    };
    return (
      <React.Fragment>
        <FormElement
          validate={this.state.validationMessage['file_name']}
          info={renderInfoBlock()}
        >
          <div className='form-list__img'>
            <div className='img-form-thumbnail'>
              {!isNullOrEmpty(this.state.params.image_url) ? (
                <img src={this.state.params.image_url} alt='' />
              ) : (
                !isNullOrEmpty(this.state.params.file_name) && (
                  <div className='pdf-preview'>
                    <div className='pdf-filename'>
                      {this.state.params.file_name}
                    </div>
                    <div>※PDFファイルの場合</div>
                    <div>プレビューが表示されません。</div>
                  </div>
                )
              )}
            </div>
            <button
              className='btn-icon form-list__element--btn_delete'
              onClick={() => {
                this.clearFile();
              }}
            >
              <TrashIcon className='icon--2_4x form-list__trash-icon' />
            </button>
            <div className='manager-request__card-guide'>
              <div>
                名刺画像の必要事項：<span className='bold'>撮影例</span>
              </div>
              <img
                src={ImageGuideManagerRequest}
                className='manager-request__card-guide__image'
              />
              <div className='manager-request__card-guide__legend'>
                <GuideLegendList/>
              </div>
            </div>
          </div>

          <Tippy
            duration={10}
            distance={16}
            arrowType='sharp'
            arrow={true}
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            html={this.renderTooltipContent(
              messageUtility.getMessage('I-000-108')
            )}
          >
            <label className='btn input-file' htmlFor='file-select'>
              ファイル選択
              <input
                id='file-select'
                name='file_name'
                type='file'
                accept='image/jpg, image/jpeg, image/png, application/pdf'
                onChange={async e => {
                  await this.uploadFile(e.target);
                }}
                onClick={e => {
                  e.target.value = '';
                }}
                style={{ display: 'none' }}
              />
            </label>
          </Tippy>
        </FormElement>
      </React.Fragment>
    );
  };

  requestMessageForm = () => {
    const setRequestMessage = e => {
      const state = _.cloneDeep(this.state);
      state.params.request_message = e.target.value;
      this.setState(state);
    };
    return (
      <React.Fragment>
        <FormElement
          info={
            <React.Fragment>
              <p>
                ※申請についてのご連絡がございましたらこちらにご記入ください。
              </p>
              <p>
                （ユーザー名または本人確認書類が旧姓である・再申請である等）
              </p>
            </React.Fragment>
          }
        >
          <textarea
            onChange={e => {
              setRequestMessage(e);
            }}
          />
        </FormElement>
      </React.Fragment>
    );
  };

  /**
   * @description 入力パラメータチェック
   * @param {object} params 入力パラメータ
   * @returns チェック結果
   */
  getValidateResult = params => {
    let result = validationByJoi(BuildeeManagerRequestScheme, params);
    result.messages = result.messages || {};
    return result;
  };

  /**
   * 更新・登録用のリクエストデータを作成する
   *
   * @param {object} params
   * @return {object} form_data
   */
  createRequestParam = params => {
    let sendParams = {};
    if (isLoginUserPartner()) {
      sendParams.company_branch_id = params.company_branch_id;
    }
    sendParams.target_user_id = params.user_id;
    sendParams.request_user_id = this.userId;
    sendParams.file_name = params.file_name;
    sendParams.request_message = params.request_message;
    sendParams.file = params.file;

    let formData = new FormData();
    _.each(sendParams, (val, key) => {
      formData.append(key, val);
    });
    return formData;
  };

  /**
   * 企業管理者申請確認ダイアログを表示
   *
   */
  showConfirmDialog() {
    const state = _.cloneDeep(this.state);
    let params = state.params;
    let result = this.getValidateResult(params);
    if (result.status) {
      state.confirmDialogFlg = true;
    } else {
      state.confirmDialogFlg = false;
      state.validationMessage = result.messages;
    }
    this.setState(state);
  }

  /**
   * 企業管理者申請確認ダイアログを閉じる
   *
   */
  closeConfirmDialog() {
    const state = _.cloneDeep(this.state);
    state.confirmDialogFlg = false;
    this.setState(state);
  }

  /**
   * 企業管理者申請を行う
   *
   * */
  submit() {
    if (this.isRequesting) {
      return;
    }
    this.isRequesting = true;
    let params = this.state.params;
    let result = this.getValidateResult(params);
    if (result.status) {
      let sendParams = this.createRequestParam(params);
      BuildeeManagerRequestApi.create(params.company_id, sendParams).then(
        response => {
          if (response.result) {
            masterSlideLoader.show('Users', { state: { id: 1 } });
          } else {
            const buildeeManagerGrantRequest = _.get(response, 'data.data.entities.buildee_manager_grant_request');
            if (buildeeManagerGrantRequest) {
              this.setState({
                confirmDialogFlg: false,
                buildeeManagerMessageFlg: true,
                buildeeManagerGrantRequest
              });
              return;
            }
            let errorMessage = '';
            if (_.isEmpty(response.message)) {
              if (!isNullOrUndefined(response.data)) {
                errorMessage = messageUtility.getMessage(
                  'E-000-007',
                  response.data.message
                );
              } else {
                // APIからエラーメッセージが取得されない場合
                errorMessage = messageUtility.getMessage('E-000-055');
              }
            } else {
              errorMessage = messageUtility.getMessage(
                'E-000-007',
                response.message
              );
            }
            this.showDialog(errorMessage);
          }
        }
      ).finally(() => {
        this.isRequesting = false;
      });
    } else {
      // エラーメッセージを表示
      this.setState(
        {
          confirmDialogFlg: false,
          validationMessage: result.messages,
        },
        () => {
          this.isRequesting = false;
        }
      );
    }
  }

  showDialog(message) {
    dialogLoader.show(
      FormInformationDialog,
      {
        onClose: () => {
          dialogLoader.close();
          this.isRequesting = false;
        },
        title: 'エラーが発生しました',
        message,
      },
      null
    );
  }

  /**
   * Tooltipで表示される文字
   * @param {string} data 表示データ
   */
  renderTooltipContent = data => {
    const rowStyle = {
      wordWrap: 'break-word',
      whiteSpace: 'pre-wrap',
      color: '#FFF',
      fontSize: '14px',
      lineHeight: '1.5',
      textAlign: 'left',
    };

    return (
      <React.Fragment>
        <div style={rowStyle}>{data}</div>
      </React.Fragment>
    );
  };

  handleConfirmation = () => {
    this.setState(state => ({
      confirmed: !state.confirmed,
    }));
  };

  handleAgreement = () => {
    this.setState(state => ({
      agreed: !state.agreed,
    }));
  };
  downloadFileManual = async () => {
    if (this.isRequesting) {
      return;
    }
    this.isRequesting = true;
    await PrintUtility.downloadStaticFilePDF(
      CORPORATE_ADMINISTRATOR_MANUAL.fileCode,
      CORPORATE_ADMINISTRATOR_MANUAL.fileName,
      this.setVisibleDownloadErrorDialog
    );
    this.isRequesting = false;
  }

  renderMessage = () => {
    return (
      <div className='ApplyConfirmDialog__body'>
        <div className='ApplyConfirmDialog__message'>
          企業管理者申請には、企業管理者説明資料をご確認のうえ下記の注意事項に同意いただく必要があります。
        </div>
        <ul className='ApplyConfirmDialog__message--list'>
          <p>＜注意事項＞</p>
          <li className='ApplyConfirmDialog__message--list-item'>
            申請は最初の1名のみとなります。2人目以降はユーザーにて設定してください。
          </li>
          <li className='ApplyConfirmDialog__message--list-item'>
            Buildee上に個人事業主として登録されている協力会社からは申請できません。
          </li>
          <li className='ApplyConfirmDialog__message--list-item'>
            申請承認後、企業管理者の利用を取り消すことはできません。
          </li>
          <li className='ApplyConfirmDialog__message--list-item'>
            企業管理者申請後に登録された自社ユーザーのサービス権限は「調整会議・入退場管理」のみになります。
            <br />
            &ensp;&emsp;「労務安全」を利用するユーザーに対して、企業管理者によるサービス権限の付与が都度必要です。
          </li>
        </ul>
        <div className='ApplyConfirmDialog__checkbox ApplyConfirmDialog__checkbox--multiline'>
          <label className='checkbox' style={{ width: 232, margin: '0 auto' }}>
            <input
              name='checkbox'
              type='checkbox'
              disabled={false}
              checked={this.state.confirmed}
              onChange={this.handleConfirmation}
            />
            <i className='i-square i-3x' />
            企業管理者説明資料を確認した
          </label>
          <label className='checkbox' style={{ width: 232, margin: '0 auto' }}>
            <input
              name='checkbox'
              type='checkbox'
              disabled={false}
              checked={this.state.agreed}
              onChange={this.handleAgreement}
            />
            <i className='i-square i-3x' />
            注意事項に同意する
          </label>
        </div>
      </div>
    );
  };

  render() {
    const masterSlideViewBodyHeight = safariOnIosCheck()
      ? 'calc(100vh - 115px)'
      : 'calc(100vh - 84px)';

    return (
      <div
        className={`${
          Styles.buildeeManagerRequestForm
        } contruction-slide-view show`}
      >
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 企業管理者の申請</title>
        </Helmet>
        <div className='contruction-slide-view__view manager-request-slide-view__view'>
          <MasterPageHeader
            title='企業管理者の申請'
            onClose={() =>
              masterSlideLoader.show('Users', { state: { id: 1 } })
            }
          />
          <div
            className='manager-request-slide-view__body'
            style={{ height: masterSlideViewBodyHeight }}
          >
            <div className='manager-request-detail-view'>
              <div className='manager-request-detail-view__body'>
                <div className='manager-request-detail-view__header'>
                  <button
                    className='btn-text--sm'
                    onClick={() =>
                      masterSlideLoader.show('Users', { state: { id: 1 } })
                    }
                  >
                    <i className='i-back--blue i-2x vertical-middle' />
                    ユーザー一覧
                  </button>
                </div>
                <div className='manager-request-detail-view__menu'>
                  <button
                    className='btn--effective'
                    onClick={() => this.showConfirmDialog()}
                  >
                    {messageUtility.getMessage('I-000-102')}
                  </button>
                </div>
                <div className='manager-request-detail-view__bar' />
                <div className='manager-request-detail-view__main'>
                  <FormList>
                    <FormListItem>
                      <div className='description'>
                        企業管理者の機能概要と注意事項については企業管理者説明資料をご確認ください。
                        <span
                          className='clickable-text'
                          onClick={this.downloadFileManual}
                          data-testid='corporate_administrator_manual_download_link'
                        >
                          企業管理者説明資料のダウンロード
                        </span>
                        <br />
                        <span className='text--warning'>
                          企業管理者機能をご利用いただく場合は、必ず注意事項に同意いただいたうえで申請をお願いします。
                        </span>
                        <br />
                        申請結果は3営業日ほどでメールにてお知らせいたします。
                        <br />
                        <br />
                        ＜企業管理者ができること＞
                        <ul>
                          <li>・自社ユーザーへの企業管理者権限の設定</li>
                          <li>・自社ユーザーへのBuildeeサービス権限の設定</li>
                          <li>・支店の登録（協力会社の場合のみ）</li>
                        </ul>
                        <br />
                        ＜注意事項＞
                        <ul>
                          <li>
                            ・申請は最初の1名のみとなります。2人目以降はユーザーにて設定してください。
                          </li>
                          <li>
                            ・Buildee上に個人事業主として登録されている協力会社からは申請できません。
                          </li>
                          <li>
                            ・申請承認後、企業管理者の利用を取り消すことはできません。
                          </li>
                          <li>
                            ・企業管理者申請後に登録された自社ユーザーのサービス権限は「調整会議・入退場管理」のみになります。
                            <br />
                            &emsp;「労務安全」を利用するユーザーに対して、企業管理者によるサービス権限の付与が都度必要です。
                            <br />
                            <span className='text--warning'>
                              &emsp;サービス権限の注意事項については企業管理者説明資料をご確認ください。
                            </span>
                          </li>
                        </ul>
                      </div>
                    </FormListItem>
                    <FormListItem label='会社名'>
                      <FormElement>
                        {this.state.params.company_name}
                      </FormElement>
                    </FormListItem>
                    <FormListItem label='支店名'>
                      <FormElement>
                        {this.state.params.user_role_code &&
                        isTargetRoleId(
                          [USER_ROLES.prime],
                          this.state.params.user_role_code
                        )
                          ? '本社'
                          : this.state.params.company_branch_name}
                      </FormElement>
                    </FormListItem>
                    <FormListItem label='申請者名'>
                      <FormElement>{this.state.params.user_name}</FormElement>
                    </FormListItem>
                    <FormListItem label='名刺画像' required={true}>
                      {this.fileInputForm()}
                    </FormListItem>
                    <FormListItem label='備考'>
                      {this.requestMessageForm()}
                    </FormListItem>
                  </FormList>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Confirmation
          visible={this.state.confirmDialogFlg}
          title={messageUtility.getMessage('I-000-109')}
          confirmButtonText={messageUtility.getMessage('I-000-102')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={this.renderMessage()}
          onConfirm={() => this.submit()}
          onCancel={() => this.closeConfirmDialog()}
          rootClassName={'ApplyConfirmDialog'}
          disabledConfirmButton={!this.state.confirmed || !this.state.agreed}
        />
        <Information
          visible={this.state.visibleDownloadErrorDialog}
          title='ダウンロードエラー'
          message={messageUtility.getMessage('E-000-033')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.setVisibleDownloadErrorDialog(false)}
          buttonClassName='btn--sub'
        />
        <BuildeeManagerApplyingModal
          visible={this.state.buildeeManagerMessageFlg}
          buildeeManagerGrantRequest={this.state.buildeeManagerGrantRequest}
          onClose={() => {
            this.setState({
              buildeeManagerMessageFlg: false
            }, () => {
              masterSlideLoader.show('Users', { state: { id: 1 } });
            });
          }}
        />
      </div>
    );
  }
}

const guideLegendList = ['会社名', '氏名', '会社住所', 'メールアドレス'];

const GuideLegendList = () => {
  return _.map(guideLegendList, (label, index) => (
    <div className='guide-legend-item' key={index}>
      <div className='guide-legend-item__no'>{index + 1}</div>
      {label}
    </div>
  ));
};



// WEBPACK FOOTER //
// ./src/pages/BuildeeManagerRequest.jsx